import React from "react";
import { Outlet, NavLink, useLocation } from "react-router-dom";
import { Store } from "lucide-react";
import { SELLER_MENU, MKT_GOLD, MKT_TINT } from "../../lib/marketplace";
import { Breadcrumb } from "../../design-system";

function SellerNav() {
  return (
    <nav className="lg:sticky lg:top-24 bg-white rounded-2xl border border-slate-100 p-2" data-testid="mkt-subnav">
      <p className="hidden lg:block px-3 pt-2 pb-3 text-[11px] uppercase tracking-widest font-bold text-slate-400">
        Centro del Vendedor
      </p>
      <ul className="flex lg:flex-col gap-1 overflow-x-auto lg:overflow-visible -mx-1 lg:mx-0 px-1 lg:px-0">
        {SELLER_MENU.map(({ to, end, label, Icon, key }) => (
          <li key={key} className="flex-shrink-0 lg:flex-shrink lg:w-full">
            <NavLink
              to={to}
              end={end}
              data-testid={`mkt-nav-${key}`}
              className={({ isActive }) =>
                [
                  "flex items-center gap-2.5 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors whitespace-nowrap lg:whitespace-normal border",
                  isActive
                    ? "border-transparent"
                    : "text-slate-600 hover:bg-slate-50 hover:text-slate-900 border-transparent",
                ].join(" ")
              }
              style={({ isActive }) =>
                isActive ? { backgroundColor: MKT_TINT, color: "#92400E", borderColor: `${MKT_GOLD}44` } : undefined
              }
            >
              <Icon size={16} />
              <span>{label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}

export default function MarketplaceLayout() {
  const location = useLocation();
  const activa = SELLER_MENU.find((s) =>
    s.end ? location.pathname === s.to : location.pathname.startsWith(s.to),
  );
  const crumbs = [
    { label: "Inicio", to: "/" },
    { label: "Marketplace", to: "/marketplace" },
    { label: activa ? activa.label : "Mi Tienda" },
  ];

  return (
    <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 py-6 lg:py-8 space-y-6" data-testid="marketplace-layout">
      <Breadcrumb items={crumbs} testid="mkt-breadcrumb" />

      {/* Header del módulo */}
      <section
        className="rounded-3xl overflow-hidden border border-slate-100 shadow-soft bg-white p-6 md:p-7"
        style={{ background: `linear-gradient(135deg, #FFFFFF 58%, ${MKT_TINT} 100%)` }}
      >
        <div className="flex items-center gap-4">
          <span
            className="w-14 h-14 rounded-2xl flex items-center justify-center shadow-sm flex-shrink-0"
            style={{ backgroundColor: "#fff", color: MKT_GOLD }}
          >
            <Store size={26} />
          </span>
          <div>
            <p className="text-[11px] font-bold uppercase tracking-[0.2em]" style={{ color: MKT_GOLD }}>
              Centro del Vendedor
            </p>
            <h1 className="mt-0.5 text-2xl md:text-3xl font-extrabold text-slate-900 tracking-tight">
              ConstruLink Marketplace
            </h1>
            <p className="text-sm text-slate-600 mt-1">
              Vende tus productos digitales para la construcción en un solo lugar.
            </p>
          </div>
        </div>
      </section>

      <div className="grid grid-cols-1 lg:grid-cols-[260px_minmax(0,1fr)] gap-6">
        <aside>
          <SellerNav />
        </aside>
        <main data-testid="mkt-content" className="min-w-0">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
